var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-block",class:{
    'top': _vm.top,
    'bottom': _vm.bottom,
    'left': _vm.left,
    'right': _vm.right,
    'right-position': _vm.rightPosition
  }},[_c('div',{staticClass:"tooltip-block__content js-tooltip",class:{
      'only-text': !_vm.title && !_vm.textLeft,
      'text-left': _vm.textLeft,
    },style:({width : (_vm.width + "px")})},[(_vm.title)?_c('UiText',{staticClass:"tooltip-block__title",attrs:{"font":"text-l","bold":"","color":"tooltip-text-color"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(_vm.text)?_c('UiText',{staticClass:"tooltip-block__text",attrs:{"font":"body-caption","color":"tooltip-text-color"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }